@use 'src/globals/main';

pn-tile {
  position: relative;
  display: block;
}

pn-tile .pn-tile {
  position: relative;

  overflow: hidden;
  word-break: break-word;
  text-align: center;

  border-radius: 0.5em;

  padding: clamp(0.75em, 3vw, 1.5em);

  height: 100%;

  color: main.$gray900;
  background-color: main.$white;
  box-shadow:
    0em 0.0625em 0.125em 0em rgba(20, 20, 20, 0.11),
    0em 0.1875em 0.4375em 0em rgba(0, 0, 0, 0.13);

  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: clamp(1em, 5vw, 1.5em);

  @include main.pn-focus-base();
  @include main.pn-transition('box-shadow, background-color, outline-color');

  @include main.pn-ripple(main.$blue700);

  &[data-horizontal] {
    text-align: left;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: clamp(1em, 5vw, 1.5em);
    .pn-tile-illustration[data-circle]:before {
      clip-path: ellipse(0% 100% at 0% 50%);
    }
    .pn-tile-text {
      flex-grow: 2;
    }
  }

  &[data-href][data-focus] {
    @include main.pn-focus-visible();
    box-shadow:
      0em 0em 0em 0em rgba(20, 20, 20, 0.11),
      0em 0em 0em 0em rgba(0, 0, 0, 0.13);
  }

  &[data-href]:hover {
    background-color: rgba(#b7ebfc, 0.3);
  }

  &[data-href]:hover,
  &[data-href]:focus-within {
    .pn-tile-illustration[data-circle]:before {
      clip-path: ellipse(100% 50% at 50% -25%);
    }
    &[data-horizontal] .pn-tile-illustration[data-circle]:before {
      clip-path: ellipse(50% 100% at -25% 50%);
    }

    .pn-tile-link {
      color: main.$blue900;
      text-decoration-color: main.$blue900;
    }

    pn-icon .pn-icon-svg path {
      fill: main.$blue900;
    }
  }

  &-illustration {
    z-index: 2;
    flex: 1 1;
    max-width: 7.5em;
    max-height: 7.5em;

    &[data-icon] {
      flex: 0 0;
      pn-icon {
        padding: 1em;
        border-radius: 50%;
        background-color: main.$blue50;
        > svg {
          font-size: 2em;
        }
      }
    }

    &-slot {
      display: block;
      height: 100%;
      width: 100%;
    }

    &[data-circle]:before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(183, 235, 252, 0.7);

      background-color: rgba(#b7ebfc, 0.7);
      clip-path: ellipse(100% 0% at 50% 0%);

      @include main.pn-transition('clip-path');
    }
  }

  &-text {
    z-index: 3;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  }

  &-link {
    cursor: pointer;
    color: main.$blue700;
    text-decoration: underline;
    text-decoration-color: transparent;
    -webkit-tap-highlight-color: transparent;

    @include main.pn-transition('color, text-decoration-color');

    &:focus {
      outline: 0;
      text-decoration-color: main.$blue900;
      color: main.$blue900;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      opacity: 0;
    }
  }

  &-title {
    font-family: inherit;
    font-weight: 700;
    font-size: clamp(1.25em, 3vw, 1.5em);
    margin: 0em;

    pn-icon {
      margin-left: 0.25em;
      vertical-align: middle;
    }
  }

  &-slot {
    font-weight: 400;
    color: main.$gray700;

    display: flex;
    flex-direction: column;
    gap: 0.25em;
  }

  &-paragraph,
  p {
    font-size: 0.875em;
    &:last-child {
      margin: 0em;
    }
  }
}
